import { Public } from '@mui/icons-material';
import React from 'react';
import Footer from './Footer';
import PublicHeader from './PublicHeader';
import './layouts.scss';
import ContactUsDialog from './ContactUsDialog';

const PublicLayout = ({ children, headerHeight }) => {

    const height = headerHeight ?? '5rem';
    return (<>
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <ContactUsDialog />
        <PublicHeader />
        <main id="main-content" tabIndex={-1}>
            {/* `public-screen` is an additive modifier (see layouts.scss) that lets this
                specific `.screen` instance (Home, 404) go fluid below 60rem, without touching
                the shared `.screen` rule that `MainLayout`'s authenticated admin/list/detail
                screens also use and intentionally keep desktop-width. */}
            <div className='screen public-screen'>
                <div className='screen__content'>
                    {children}
                </div>
            </div>
        </main>
        <Footer />
    </>
    );
}

export default PublicLayout;


